import * as React from 'react';
import icon from '../../assets/img/flags/kansas.svg';

export const Kansas = (props) => <img src={icon} height={props.height || 100} alt="Flag" />;
